import { memo, SVGProps } from 'react'

export const SearchIcon = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.7421 15.0369C12.2197 15.0369 15.0389 12.2178 15.0389 8.74015C15.0389 5.26253 12.2197 2.44336 8.7421 2.44336C5.26448 2.44336 2.44531 5.26253 2.44531 8.74015C2.44531 12.2178 5.26448 15.0369 8.7421 15.0369Z"
      stroke="#737C88"
      strokeWidth="2.14286"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5584 17.5545L13.9062 13.9023"
      stroke="#737C88"
      strokeWidth="2.14286"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
))

export const CloseIcon = memo((props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.697 4.575L4.575 6.697 9.88 12l-5.304 5.303 2.122 2.122L12 14.12l5.303 5.304 2.122-2.122L14.12 12l5.304-5.303-2.122-2.122L12 9.88 6.697 4.575z"
        fill="currentColor"
      />
    </svg>
  )
})
